import { getBasePath } from "@/shared/config";
import {
  DiscordLogoIcon,
  InstagramLogoIcon,
  YoutubeLogoIcon,
  FarcasterLogoIcon,
  XLogoIcon,
} from "./icons";
import {
  AB_FLAGSHIP_URL,
  getActivityPath,
  getArtistResidencyApplicationPath,
  getRankingsPath,
  getStudioApplicationPath,
  getUpcomingPath,
} from "@/client/lib/links";

export type NavItem = {
  label: React.ReactNode;
  value: string;
  subItems?: NavItem[];
} & (
  | { href: string; onClick?: () => void }
  | { href?: string; onClick: () => void }
);

export const NAV_ITEMS: Array<NavItem> = [
  {
    label: "Calendar",
    value: "calendar",
    href: `${AB_FLAGSHIP_URL}/calendar`,
  },
  {
    label: "Collections",
    href: `${AB_FLAGSHIP_URL}/discover`,
    value: "collections",
    subItems: [
      {
        label: "Discover all",
        value: "discover-all",
        href: `${AB_FLAGSHIP_URL}/discover`,
      },
      {
        label: "AB[500]",
        value: "ab-500",
        href: `${AB_FLAGSHIP_URL}/discover/ab-500`,
      },
      {
        label: "Curated",
        value: "curated-collections",
        href: `${AB_FLAGSHIP_URL}/discover/curated`,
      },
      {
        label: "Studio",
        value: "studio-collections",
        href: `${AB_FLAGSHIP_URL}/discover/studio`,
      },
      {
        label: "Presents",
        value: "presents-collections",
        href: `${AB_FLAGSHIP_URL}/discover/presents`,
      },
      {
        label: "Engine",
        value: "engine-collections",
        href: `${AB_FLAGSHIP_URL}/discover/engine`,
      },
    ],
  },
  {
    label: "Artists",
    href: `${AB_FLAGSHIP_URL}/artists`,
    value: "artists",
    subItems: [
      {
        label: "Featured artist",
        value: "featured-artist",
        href: `${AB_FLAGSHIP_URL}/artists`,
      },
      {
        label: "All artists",
        value: "all-artists",
        href: `${AB_FLAGSHIP_URL}/artists?tab=All+Artists`,
      },
      {
        label: "Apply as an artist",
        value: "artist-application",
        href: getStudioApplicationPath(),
      },
      {
        label: "Apply for artist residency",
        value: "artist-residency",
        href: getArtistResidencyApplicationPath(),
      },
    ],
  },
  {
    label: "Learn",
    href: `${AB_FLAGSHIP_URL}/articles`,
    value: "learn",
    subItems: [
      {
        label: "The Journal",
        value: "journal",
        href: `${AB_FLAGSHIP_URL}/articles`,
      },
      {
        label: "How to purchase",
        value: "how-to-purchase",
        href: `${AB_FLAGSHIP_URL}/articles/art-blocks-auctions-and-minters`,
      },
      {
        label: "Technical docs",
        value: "technical-docs",
        href: "https://docs.artblocks.io",
      },
    ],
  },
  {
    label: "Marketplace",
    href: `${AB_FLAGSHIP_URL}/secondary-marketplace`,
    value: "marketplace",
    subItems: [
      {
        label: "Secondary marketplace",
        value: "secondary-marketplace",
        href: `${AB_FLAGSHIP_URL}/secondary-marketplace`,
      },
      {
        label: "Listing activity",
        value: "activity",
        href: getActivityPath(),
      },
      {
        label: "Collection rankings",
        value: "rankings",
        href: getRankingsPath(),
      },
    ],
  },
  {
    label: "About",
    href: `${AB_FLAGSHIP_URL}/articles/about-art-blocks-curated`,
    value: "about",
    subItems: [
      {
        label: "About us",
        value: "about-us",
        href: `${AB_FLAGSHIP_URL}/articles/about-art-blocks-curated`,
      },
      {
        label: "Our on-chain vision",
        value: "our-on-chain-vision",
        href: "/onchain",
      },
    ],
  },
  {
    label: <DiscordLogoIcon className="w-sm h-sm fill-on-surface" />,
    value: "discord",
    href: "https://discord.gg/artblocks",
  },
];

export type SocialLink = {
  icon: React.ElementType;
  href: string;
};

export const SOCIAL_LINKS: SocialLink[] = [
  {
    icon: XLogoIcon,
    href: "https://twitter.com/artblocks_io",
  },
  {
    icon: DiscordLogoIcon,
    href: "https://discord.com/invite/artblocks",
  },
  {
    icon: FarcasterLogoIcon,
    href: "https://warpcast.com/artblocks",
  },
  {
    icon: YoutubeLogoIcon,
    href: "https://www.youtube.com/channel/UCJ3do9nWP6qaJkcbxZaJZ4w",
  },
  {
    icon: InstagramLogoIcon,
    href: "https://www.instagram.com/artblocks_io",
  },
];
